module.exports = __webpack_public_path__ + "img/risklevelR3.df713d9f.png";